import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../components/ui/SafeIcon'

const { FiShield, FiTruck, FiDollarSign, FiHeadphones, FiCheckCircle } = FiIcons

function BuyerCentralPage() {
  const features = [
    { icon: FiShield, title: 'Trade Assurance', description: 'Schutz Ihres Geldes vom Bestellzeitpunkt bis zur Lieferung', color: 'text-green-600', bgColor: 'bg-green-100' },
    { icon: FiTruck, title: 'Logistik Services', description: 'Komplette Logistik-Lösungen von China nach Europa', color: 'text-blue-600', bgColor: 'bg-blue-100' },
    { icon: FiDollarSign, title: 'Zahlungsschutz', description: 'Sichere Zahlungsabwicklung mit 100% Käuferschutz', color: 'text-orange-600', bgColor: 'bg-orange-100' },
    { icon: FiHeadphones, title: 'Deutscher Support', description: 'Persönliche Betreuung auf Deutsch für alle Anfragen', color: 'text-purple-600', bgColor: 'bg-purple-100' }
  ]

  const guides = [
    { title: 'Import-Leitfaden', description: 'Schritt-für-Schritt Anleitung für den China-Import', link: '/guide/import' },
    { title: 'Zollabwicklung', description: 'Alles über Zollformalitäten und Einfuhrsteuern', link: '/guide/customs' },
    { title: 'Qualitätssicherung', description: 'Wie Sie Produktqualität sicherstellen können', link: '/guide/quality' },
    { title: 'Zahlungsmethoden', description: 'Übersicht aller verfügbaren Zahlungsmethoden', link: '/guide/payment' }
  ]

  return (
    <>
      <Helmet>
        <title>Käufer-Zentrum - Hilfe & Support | 1688Euro.com</title>
        <meta name="description" content="Käufer-Zentrum bei 1688Euro.com - Alles für erfolgreiche Importe aus China. Trade Assurance, Logistik-Services und deutscher Support." />
        <meta name="keywords" content="Käufer-Zentrum,Import China,Hilfe,Support,Trade Assurance,Logistik,Zollabwicklung,1688Euro.com" />
        <link rel="canonical" href="https://1688euro.com/buyer-central" />
      </Helmet>

      <div className="min-h-screen bg-[#F2F3F7] py-8">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 mb-8 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Käufer-Zentrum - 1688Euro.com</h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto"> Alles, was Sie für erfolgreiche Einkäufe auf 1688Euro.com benötigen - von der Bestellung bis zur Lieferung </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {features.map((feature, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                <div className={`w-12 h-12 ${feature.bgColor} rounded-lg flex items-center justify-center mb-4`}>
                  <SafeIcon icon={feature.icon} className={`w-6 h-6 ${feature.color}`} />
                </div>
                <h3 className="font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Guides Section */}
          <div className="bg-white rounded-lg border border-gray-200 p-8 mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Hilfreiche Leitfäden für Ihren Import</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {guides.map((guide, index) => (
                <Link
                  key={index}
                  to={guide.link}
                  className="flex items-start space-x-4 p-4 border border-gray-200 rounded-lg hover:border-[#FF6600] hover:shadow-md transition-all"
                >
                  <SafeIcon icon={FiCheckCircle} className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">{guide.title}</h3>
                    <p className="text-sm text-gray-600">{guide.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-[#FF6600] to-orange-500 rounded-lg p-8 text-center text-white">
            <h2 className="text-2xl font-bold mb-4">Bereit für Ihre erste Bestellung bei 1688Euro.com?</h2>
            <p className="mb-6 opacity-90">Starten Sie jetzt mit dem direkten Import aus China</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/search?q=alle" className="bg-white text-[#FF6600] px-6 py-3 rounded-lg font-bold hover:bg-gray-100 transition-colors">
                Produkte entdecken
              </Link>
              <Link to="/help" className="border border-white text-white px-6 py-3 rounded-lg font-bold hover:bg-white hover:text-[#FF6600] transition-colors">
                Hilfe benötigt?
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BuyerCentralPage